import { Routes } from '@angular/router';

export const flavourAppRoutes: Routes = [
  {
    path: 'client/heart-with-health/hwh-register',
    loadChildren: () =>
      import('src/app/client/heart-with-health/pages/hwh-register/hwh-register.module').then(
        (m) => m.HwhRegisterPageModule,
      ),
  },
  {
    path: 'client/heart-with-health/hwh-login',
    loadChildren: () =>
      import('src/app/client/heart-with-health/pages/hwh-login/hwh-login.module').then(
        (m) => m.HwhLoginPageModule,
      ),
  },
];

export const flavourHomeRoutes: Routes = [
  {
    path: 'hwh-dashboard',
    loadComponent: () =>
      import('src/app/client/heart-with-health/pages/hwh-dashboard/hwh-dashboard.page').then(
        (m) => m.HwhDashboardPage,
      ),
  },
  {
    path: 'hwh-biometrics',
    loadComponent: () =>
      import('src/app/client/heart-with-health/pages/hwh-biometrics/hwh-biometrics.page').then(
        (m) => m.HwhBiometricsPage,
      ),
  },
  {
    path: 'hwh-course-list/:category',
    loadComponent: () =>
      import('src/app/client/heart-with-health/pages/hwh-course-list/hwh-course-list.page').then(
        (m) => m.HwhCourseListPage,
      ),
  },
];

export const flavourChatRoutes: string[] = ['/home/hwh-dashboard', '/home/hwh-biometrics'];

export const flavourFullScreenRoutes: string[] = ['/client/heart-with-health/hwh-register'];

export const flavourPageTitleKeys: Array<{ match: string; key: string }> = [
  { match: '/client/heart-with-health/hwh-login', key: 'shared-page.title.login' },
  { match: '/client/heart-with-health/hwh-register', key: 'shared-page.title.register' },
  { match: '/home/hwh-dashboard', key: 'shared-page.title.health-score' },
  { match: '/home/hwh-biometrics', key: 'shared-page.title.health-score' },
];
